/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-27 12:55:55
 *
 * LastModified: 2017-05-27 12:55:55
 *-------------------------------------------------------*/

import _ from 'lodash'

const DEFAULT_LIMIT = 10;
const DEFAULT_SKIP = 0;

const defaultState = {
	listAll: [],
	listFilter: [],
	listPaging: [],
	filter: {
		plan: 'all',
		limit: DEFAULT_LIMIT,
		skip: DEFAULT_SKIP
	}
};

function listUsers(state = defaultState, action) {
	switch (action.type) {
		case 'RESET_ALL_USERS_STATE':
			return defaultState;
		case 'GET_ALL_USERS': {
			const filter = state.filter;
			filter.keyword = _.get(action.payload, 'filter.where.and.[2].email.regexp', '')
			return {
				...state,
				filter
			}
		}
		case 'GET_ALL_USERS_SUCCESS': {
			const filter = state.filter;
			filter.skip = 0;
			const listAll = action.payload.data;
			const listFilter = listAll.filter(el => {
				if (el.id === 1 || el.id === 2) return false;
				if (filter.plan === 'free') {
					return el.totalModel === 5;
				} else if (filter.plan === 'pro') {
					return el.totalModel !== 5;
				}
				return true;
			});
			const listPaging = [...listFilter].splice(filter.skip * filter.limit, filter.limit);
			return {
				...state,
				listAll,
				listFilter,
				listPaging
			};
		}
		// case 'EDIT_REQUEST_SUCCESS': {
		// 	const index = state.data.findIndex(el => {
		// 		return el.id === action.payload.id;
		// 	});

		// 	state.data[index] = { ...state.data[index], ...action.payload };

		// 	return { ...state };
		// }
		case 'GET_USERS_BY_PAGINATION': {
			const filter = state.filter;
			filter.skip = action.payload.skip;
			const listFilter = state.listFilter;
			const listPaging = [...listFilter].splice(filter.skip * filter.limit, filter.limit);
			return {
				...state,
				listPaging,
				filter
			};
		}
		case 'GET_USERS_BY_PLAN': {
			const filter = { limit: DEFAULT_LIMIT, skip: DEFAULT_SKIP };
			filter.plan = action.payload.plan;
			const listAll = state.listAll;
			const listFilter = listAll.filter(el => {
				if (el.id === 1 || el.id === 2) return false;
				if (filter.plan === 'free') {
					return el.totalModel === 5;
				} else if (filter.plan === 'pro') {
					return el.totalModel !== 5;
				}
				return true;
			});
			const listPaging = [...listFilter].splice(filter.skip * filter.limit, filter.limit);
			return {
				...state,
				listFilter,
				listPaging,
				filter
			};
		}
		default:
			return state;
	}
}

export default listUsers;



// WEBPACK FOOTER //
// ./routes/admin/routes/users/reducer/list.js